import React, { createContext, useState, useContext, useEffect } from 'react';

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState(() => {
    // Initialize cart from localStorage if available
    const savedCart = localStorage.getItem('cart');
    return savedCart ? JSON.parse(savedCart) : [];
  });

  // Update localStorage whenever cart changes
  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify(cart));
  }, [cart]);

  const addToCart = (book) => {
    setCart(prevCart => {
      const existingBook = prevCart.find(item => item.book_id === book.book_id);
      if (existingBook) {
        return prevCart.map(item =>
          item.book_id === book.book_id
            ? { ...item, price: Number(item.price), quantity: item.quantity + 1 }
            : item
        );
      }
      //return [...prevCart, { ...book, quantity: 1 }];
      return [
        ...prevCart,
        {
          ...book,
          price: Number(book.price),
          quantity: 1,
          inscription: {
            inscription_name: "",
            student_name: "",
            teacher_name: "",
            grade_level: ""
          }
        }
      ];
    });
    // console.log(cart, 'cart')
  };

  const removeFromCart = (bookId) => {
    setCart(prevCart => prevCart.filter(item => item.book_id !== bookId));
  };

  const updateQuantity = (bookId, quantity) => {
    setCart(prevCart =>
      prevCart.map(item =>
        item.book_id === bookId ? { ...item, quantity } : item
      )
    );
  };

  const clearCart = () => {
    setCart([]);
  };

  const updateInscription = (bookId, key, value) => {
    setCart(prev =>
      prev.map(item =>
        item.book_id === bookId
          ? {
            ...item,
            inscription: {
              ...item.inscription,
              [key]: value
            }
          }
          : item
      )
    );
  };


  return (
    <CartContext.Provider value={{ cart, addToCart, removeFromCart, updateQuantity, clearCart, updateInscription }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within a CartProvider');
  }
  return context;
}; 